// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".scroll-container[data-v-37df8e32] {\n  white-space: nowrap;\n  position: relative;\n  overflow: hidden;\n  width: 100%;\n}\n.scroll-container[data-v-37df8e32] .el-scrollbar__bar {\n    bottom: 0px;\n}\n.scroll-container[data-v-37df8e32] .el-scrollbar__wrap {\n    height: 49px;\n}\n", ""]);
// Exports
module.exports = exports;
